import React from 'react';

export const Smile = props => {
    return (
        <svg
            className={props.extraClasses}
            width="100%"
            height="30px"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 375 30"
            xmlSpace="preserve"
        >
        <path
            fill="#ECF4FC"
            d="M0,1v29h375V1c0,0-75.5,24.5-187.1,24.5C65,25.5,0,1,0,1z" />
        <path
            fill={props.color}
            d="M187.9,14.5C65,14.5,0,0,0,0v1c0,0,65,24.5,187.9,24.5C299.5,25.5,375,1,375,1V0C375,0,299.5,14.5,187.9,14.5z" />
    </svg>
    )
};

export default Smile;


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/Smile-svg.js